import * as HTTP from './http';

export const OrderValidStatuses = async() => {
    let endpoint = `catalogs/ordersvalidstatuses`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: catalogs.ordersvalidstatuses\n${e}`);
        return undefined;
    }

    return result;
}
